import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { Cookie, X } from "lucide-react";

const CookieConsent = () => {
  const { hasConsented, acceptCookies, isLoading } = useCookieConsent();

  if (isLoading || hasConsented) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-card border-t border-border animate-fade-in">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Cookie className="w-5 h-5 text-primary flex-shrink-0" />
          <p className="text-sm text-muted-foreground">
            Wij gebruiken cookies om je ervaring te verbeteren. Door verder te gaan ga je hiermee akkoord.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button onClick={acceptCookies} variant="glow" size="sm" className="flex-shrink-0">
            Accepteren
          </Button>
          <button 
            onClick={acceptCookies}
            className="p-1 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Sluiten"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
